import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { SEO_DEFAULTS, SEO_PAGES } from "../../constants/seo";
import { isRtlLanguage } from "../../utils/i18n";
import { buildAbsoluteUrl } from "../../utils/seo";

function SeoHead({ pageId = "home", overrides = null }) {
  const { t, i18n } = useTranslation();
  const page = SEO_PAGES[pageId] || SEO_PAGES.home;
  const isRtl = isRtlLanguage(i18n.language);

  const title = overrides?.title || t(page.titleKey);
  const description = overrides?.description || t(page.descriptionKey);
  const keywords = overrides?.keywords || t(page.keywordsKey);
  const canonicalPath = overrides?.path || page.path;
  const canonicalUrl = buildAbsoluteUrl(canonicalPath);
  const ogImage = overrides?.image || buildAbsoluteUrl(SEO_DEFAULTS.ogImagePath);
  const ogType = overrides?.ogType || "website";
  const ogLocale = isRtl ? "ar_EG" : "en_US";
  const ogLocaleAlternate = isRtl ? "en_US" : "ar_EG";

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={SEO_DEFAULTS.siteName} />
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={SEO_DEFAULTS.siteName} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content={ogLocale} />
      <meta property="og:locale:alternate" content={ogLocaleAlternate} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {SEO_DEFAULTS.twitterHandle ? (
        <meta name="twitter:site" content={SEO_DEFAULTS.twitterHandle} />
      ) : null}
    </Helmet>
  );
}

export default SeoHead;
